import { createActionGroup } from '@ngrx/store';

export const CaracteristiqueTemplateActions = createActionGroup({
  source: 'Caracteristique Template',
  events: {}
});
